import { useEffect } from 'react';

import Checkbox from '../../Forms/Input/Checkbox';
import InputField from '../../Forms/Input/InputField';
import SimpleSearchSelect from '../../Forms/Input/SimpleSearchSelect';

import { ProductFormValues } from '../../../types/product/ProductFormValues';
import { useBranch } from '../../../hooks/branches/useBranch';
import { useProduct } from '../../../hooks/useProduct';

interface Props {
  form: ProductFormValues;

  onChange: (field: keyof ProductFormValues, value: any) => void;
}

const ProductInitialInventorySection = ({ form, onChange }: Props) => {
  const { branchDropdown, fetchBranchDropdown } = useBranch();
  const { formErrors } = useProduct();

  useEffect(() => {
    fetchBranchDropdown();
  }, []);

  return (
    <div className="space-y-4">
      <Checkbox
        label="Registrar inventario inicial automáticamente"
        checked={!!form.createInitialStock}
        onChange={() =>
          onChange('createInitialStock', !form.createInitialStock)
        }
      />

      {form.createInitialStock && (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <p className="col-span-full text-xs text-slate-500 dark:text-slate-400">
            El stock inicial debe ser mayor a 0 para registrarse. Si aún no
            tiene existencias, deje esta sección sin marcar y registre el
            inventario más adelante desde el módulo de Inventario.
          </p>

          <SimpleSearchSelect
            label="Sucursal"
            name="initialStockBranchId"
            iconKey="branch"
            options={branchDropdown}
            selectedValue={form.initialStockBranchId}
            onSelect={(option) => onChange('initialStockBranchId', option.id)}
            error={formErrors.initialStockBranchId}
          />

          <InputField
            label="Stock Inicial"
            name="stock"
            type="number"
            iconKey="box"
            value={form.stock ?? ''}
            onChange={(e) =>
              onChange(
                'stock',
                e.target.value === '' ? null : Number(e.target.value)
              )
            }
            error={formErrors.stock}
          />

          <InputField
            label="Costo Promedio"
            name="cost"
            type="number"
            iconKey="dollar"
            value={form.cost ?? ''}
            onChange={(e) =>
              onChange(
                'cost',
                e.target.value === '' ? null : Number(e.target.value)
              )
            }
            error={formErrors.cost}
          />

          <InputField
            label="Stock Mínimo"
            name="minStock"
            type="number"
            iconKey="warning"
            value={form.minStock ?? ''}
            onChange={(e) =>
              onChange(
                'minStock',
                e.target.value === '' ? null : Number(e.target.value)
              )
            }
            error={formErrors.minStock}
          />

          <InputField
            label="Punto de Reorden"
            name="reorderPoint"
            type="number"
            iconKey="refresh"
            value={form.reorderPoint ?? ''}
            onChange={(e) =>
              onChange(
                'reorderPoint',
                e.target.value === '' ? null : Number(e.target.value)
              )
            }
            error={formErrors.reorderPoint}
          />
        </div>
      )}
    </div>
  );
};

export default ProductInitialInventorySection;
